import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import styles from "../commanstyles.module.css";
import FinancialDocuments from "./FinancialDocuments";
import { postReferenceDocument, getDocumentCategories } from "../../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";

function SourceDocuments({ isSubScribe, refreshLoading }) {
  const { cin } = useParams();
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState(() => sessionStorage.getItem("sourceDocumentsTab") || "");
  const [documentData, setDocumentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getDocumentCategories();
        if (response.data && response.data.Status === 1 && response.data.category_name) {
          setCategories(response.data.category_name);
          const savedTab = sessionStorage.getItem("sourceDocumentsTab");
          if (savedTab && response.data.category_name.includes(savedTab)) {
            setActiveTab(savedTab);
          } else if (response.data.category_name.length > 0) {
            setActiveTab(response.data.category_name[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };
    fetchCategories();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (activeTab) {
      sessionStorage.setItem("sourceDocumentsTab", activeTab);
      setCurrentPage(1); // Reset to first page when tab changes
    }
  }, [activeTab]);

  const fetchDocuments = useCallback(async (documentCategory, page) => {
    if (!cin || !documentCategory) {
      if (!cin) setError("CIN is required to fetch documents.");
      setDocumentData([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const payload = {
        CIN: cin,
        documentCategory: documentCategory,
        page: page,
        limit: 10
      };
      const response = await postReferenceDocument(payload);
      if (response.data && response.data.Status === 1) {
        setDocumentData(response.data.getReferenceDocuments || []);
        if (response.data.pagination) {
            setTotalPages(response.data.pagination.totalPages || 1);
        }
      } else {
        setError(response.data?.message || "Failed to fetch documents.");
        setDocumentData([]);
        setTotalPages(1);
      }
    } catch (err) {
      setDocumentData([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  }, [cin]);

  useEffect(() => {
    if (cin && activeTab && !refreshLoading) {
      fetchDocuments(activeTab, currentPage);
    }
  }, [activeTab, cin, fetchDocuments, refreshLoading, currentPage]);

  const renderTableContent = () => {
    if (loading)
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <RotatingLines height="80" width="80" color="#4fa94d" ariaLabel="circles-loading" visible={true} />
        </div>
      );

    if (error) {
      return <div>{error}</div>;
    }

    if (activeTab) {
      return (
        <FinancialDocuments 
          documents={documentData} 
          isSubScribe={isSubScribe} 
          activeTab={activeTab} 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      );
    }

    return null;
  };

  return (
    <div className={styles.structure_container}>
      <div className={styles.Compilance_container}>
        <div className={styles.finace_subcontainer}>
          <div className={styles.finac_box}>
            {categories.map((item, index) => (
              <div
                key={index}
                className={`${styles.finac_box_text_container} ${activeTab === item ? styles.Active_subTab : ""}`}
                onClick={() => setActiveTab(item)}
              >
                <h4 className={styles.finac_box_header}>{item}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Render documents or no data */}
      {renderTableContent()}
    </div>
  );
}

export default SourceDocuments;

